import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UploadedFileService {
    constructor(private http: HttpClient) {}

    public delete(fileId: number): Observable<void> {
        return this.http.delete<void>('api/uploadedfile/delete', {
            params: new HttpParams({
                fromObject: {
                    fileId: fileId.toString()
                }
            })
        });
    }
}
